import { Dispatch } from "../../controller";
import { Model,StateProps, ModelProps } from "../../model";
import { TipoMovDesc, TipoMovimentacao } from "../../data.types";
import { getNewId } from "../../services/utils";

export type { TipoMovimentacao } from "../../data.types"

export interface TipoMovState extends StateProps<TipoMovimentacao> {
    tabValue:number    
}

export interface TipoMovActions extends Dispatch<TipoMovimentacao> {
    startDocTipoMov:()=>any
    setTabValue:(value:number)=>any
}

const model = new Model<TipoMovimentacao,TipoMovState>("tipomov");

const intialValueTipoMov:TipoMovimentacao = {
    ...model.getInitialValue(),
     type:"tipomov",
     descricao:"",
     detalhes:"",
     direcao_estoque:"",
     mov_estoque:false,
     alterar_item:false,
     gera_mov_fin:false,
}

export const tipoMovsDefault:TipoMovimentacao[] = [
    {
        ...model.getInitialValue(),
        _id:getNewId(),
        type:"tipomov",
        descricao:TipoMovDesc.COMPRA,
        detalhes:"Compra de itens",
        alterar_item:true,
        direcao_estoque:"E",
        gera_mov_fin:false,
        mov_estoque:true,
    },
    {
        ...model.getInitialValue(),
        _id:getNewId(),
        type:"tipomov",
        descricao:TipoMovDesc.VENDA,
        detalhes:"Venda direta de itens",
        alterar_item:false,
        direcao_estoque:"S",
        gera_mov_fin:true,
        mov_estoque:true,
    },
    {
        ...model.getInitialValue(),
        _id:getNewId(),
        type:"tipomov",
        descricao:TipoMovDesc.PEDIDO,
        detalhes:"Pedido de itens para entrega",
        alterar_item:false,
        direcao_estoque:"S",
        gera_mov_fin:true,
        mov_estoque:true,
    },
    {
        ...model.getInitialValue(),
        _id:getNewId(),
        type:"tipomov",
        descricao:TipoMovDesc.AVARIA,
        detalhes:"Saída de itens avariados",
        alterar_item:false,
        direcao_estoque:"S",
        gera_mov_fin:false,
        mov_estoque:true,
    },     
]

export const initialValueTipoMovState:TipoMovState = {
    ...model.getInititalValueState(),
    row:tipoMovsDefault[2], //default to Pedido
    tabValue:2
}


